const SearchIconInHeader = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <rect opacity="0.2" width="40" height="40" rx="8" fill="white" />
      <path
        d="M30.3124 31.2498C30.0724 31.2498 29.8322 31.1578 29.6496 30.9751L22.5621 23.8877C22.1954 23.521 22.1954 22.9286 22.5621 22.5621C22.9286 22.1954 23.5212 22.1954 23.8877 22.5621L30.9751 29.6494C31.3416 30.0161 31.3416 30.6085 30.9751 30.9751C30.7923 31.1578 30.5523 31.2498 30.3124 31.2498Z"
        fill="#D9D9D9"
      />
      <path
        d="M17.6562 8.75C12.7455 8.75 8.75 12.7455 8.75 17.656C8.75 22.5667 12.7455 26.5623 17.6562 26.5623C22.5667 26.5623 26.5623 22.5667 26.5623 17.656C26.5623 12.7455 22.5667 8.75 17.6562 8.75Z"
        fill="white"
      />
    </svg>
  );
};
export default SearchIconInHeader;
